import { useState } from 'react'

import { awaitPendingJob, displayErrorToast } from '../helpers'
import { toast } from 'sonner'
import { QueryKey, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

export interface RefreshDataOptions {
  retriever: (
    id: number,
    params?: Record<string, string>,
  ) => Promise<{ job_id: string }>
  params?: Record<string, string>
  id?: number
  successKey?: string
  callback?: () => void
  queryToInvalidate?: QueryKey
}

export const useRefreshData = (options: RefreshDataOptions) => {
  const { t } = useTranslation()
  const { retriever, id, params, successKey, callback, queryToInvalidate } =
    options
  const queryClient = useQueryClient()
  const [refreshing, setRefreshing] = useState(false)
  const [updateTriggeredAt, setUpdateTriggeredAt] = useState<Date>()

  const refreshData = (customId?: number) => {
    setRefreshing(true)
    setUpdateTriggeredAt(new Date())

    retriever(customId ?? (id as number), params)
      .then(async (response) => {
        awaitPendingJob(response.job_id, (result) => {
          if (result.error) {
            displayErrorToast(result.error, t)
          } else {
            if (successKey) toast.success(t(successKey))
            if (callback) callback()
            if (queryToInvalidate) {
              queryClient.invalidateQueries({ queryKey: queryToInvalidate })
            }
          }
          setRefreshing(false)
        })
      })
      .catch((response) => {
        displayErrorToast(response, t)
        setRefreshing(false)
      })
  }

  return {
    refreshData,
    refreshing,
    updateTriggeredAt,
  }
}
